<template>
  <div class="collection-item-box" @click="$emit('click')">
    <slot></slot>
    <hr>
    <div class="flex justify-between">
      <vue-tag icon="vintage-wall-clock-solid">{{ createdAt }}</vue-tag>
      <vue-tag :class="readClass" :icon="readIcon">{{ isRead ? 'Lu' : 'Non lu'}}</vue-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    createdAt: {
      type: String,
      required: true,
    },
    isRead: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    readClass() {
      return this.isRead ? '' : 'bg-green-lightest text-green';
    },

    readIcon() {
      return this.isRead ? 'view-solid' : 'hide-password-solid';
    },
  },
};
</script>